import React, { Component } from "react";
import CommonServices from "../../services/axioServices/apiServices/CommonServices.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faSpinner, faTrash } from "@fortawesome/free-solid-svg-icons";
import ItemMasterServices from "../../services/axioServices/apiServices/ItemMasterServices.js";
import SwalServices from "../../services/swalServices/SwalServices.js";

class LabelClaimMaster extends Component {
  constructor(props) {
    super(props);
    this.commonServices = new CommonServices();
    this.itemMasterServices = new ItemMasterServices();
    this.SwalServices = new SwalServices();
    this.state = {
      _id: "",
      isEditing: false,
      isLoading: false,
      labelClaimList: [],
      tableStatus: "",
      labelClaimDetails: {
        labelClaim: "",
      },
    };
  }

  componentDidMount() {
    this.getAllLabelClaims();
  }

  getAllLabelClaims = () => {
    this.setState({ tableStatus: "Loading..." })
    this.commonServices.getAllLabelClaims().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        if (response.responseData.length === 0) {
          this.setState({ tableStatus: "No Record Found" })
        } else {
          this.setState({ tableStatus: "" })
        }
        this.setState(
          { labelClaimList: response.responseData });
      } else {
        this.setState({ tableStatus: "" })
        this.SwalServices.Error(response.Message);
      }
    });
  };

  addEditLabelClaims = () => {
    if (this.state.labelClaimDetails.labelClaim !== "") {
      this.setState({ isLoading: true }, () => {
        let request = this.state.labelClaimDetails;
        if (this.state._id && this.state._id !== "") {
          request._id = this.state._id;
        } else {
          delete request._id;
        }
        this.itemMasterServices.addEditLabelClaims(request).then((response) => {
          if (response.statusCode === 200 && response.responseData != null) {
            this.resetForm();
            this.SwalServices.Success(response.Message);
            this.setState({ isLoading: false })
          } else {
            this.SwalServices.Error(response.Message);
            this.setState({ isLoading: false })
          }
        });
      })
    } else {
      this.SwalServices.Alert("Please fill all the required things.");
    }
  };

  resetForm = () => {
    let details = this.state.labelClaimDetails;
    details.labelClaim = "";
    this.setState({ labelClaimDetails: details }, () => {
      this.setState({ _id: "", isEditing: false, tableStatus: "" }, () => {
        console.log(this.state._id);
        this.getAllLabelClaims();
      });
    });
  };

  handleChange = (event, name) => {
    let value = event.target.value;
    let details = this.state.labelClaimDetails;
    details[name] = value.toUpperCase();
    this.setState({ labelClaimDetails: details });
  };

  getLabelClaimById = (group) => {
    let details = this.state.labelClaimDetails;
    details.labelClaim = group.labelClaim;
    this.setState({ labelClaimDetails: details, _id: group._id }, () => {
      this.setState({ isEditing: true });
    });
  };

  deleteLabelClaimById = (id) => {
    this.itemMasterServices.deleteLabelClaimById(id).then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        this.SwalServices.Success(response.Message);
        this.resetForm();
        this.getAllLabelClaims();
      } else {
        this.SwalServices.Error(
          response.Message
        );
      }
    });
  };

  closeGridView = () => {
    this.resetForm();
  };

  render() {
    return (
      <div className="item-category">
        <div className="item-form">
          <div className="form-table">
            <div className="item-grp !w-[50%] !mb-3.5">
              <label>Label Claim</label>
              <input
                className="inputFocus"
                type="text"
                id="labelClaim"
                name="labelClaim"
                autoComplete="off"
                value={this.state.labelClaimDetails.labelClaim}
                onChange={(event) => this.handleChange(event, "labelClaim")}
              />
            </div>
            <div className="btn-grp">
              {this.state.isEditing === true ? (
                <button
                  className="add-btn"
                  disabled={this.state.isLoading}
                  onClick={() => this.addEditLabelClaims()}
                >
                  {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Save"}
                </button>
              ) : (
                <button
                  className="add-btn" 
                  disabled={this.state.isLoading}
                  onClick={() => this.addEditLabelClaims()}
                >
                  {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Add"}
                </button>
              )}
              <button className="cancel-btn" onClick={() => this.closeGridView()}>
                cancel
              </button>
            </div>
          </div>
          <div className="itemList-table w-[60%] mt-4">
            <div className="table-container" style={{ height: 'calc(100vh - 185px)', }}>
              <table className="itemList">
                <thead>
                  <tr>
                    <td style={{ width: '80%' }}>Label</td>

                    <td style={{ width: '20%', textAlign: 'center' }}>Action</td>
                  </tr>
                </thead>
                <tbody>
                  {this.state.labelClaimList &&
                    this.state.labelClaimList.length > 0 ?
                    this.state.labelClaimList.map((group, key) => (
                      <tr key={key}>
                        <td>{group.labelClaim}</td>

                        <td style={{ textAlign: 'center' }}>
                          <button
                            className="search-btn"
                            onClick={() => this.getLabelClaimById(group)}
                          >
                            <FontAwesomeIcon icon={faPen} />
                          </button>
                          <button
                            className="cancel-btn"
                            onClick={() => this.deleteLabelClaimById(group._id)}
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </button>
                        </td>
                      </tr>
                    )) : this.state.labelClaimList &&
                      this.state.labelClaimList.length === 0
                      && this.state.tableStatus !== "" ? (
                      <tr>
                        <td colSpan={2} style={{ textAlign: "center", fontSize: "16px" }}>
                          {this.state.tableStatus}
                        </td>
                      </tr>
                    ) : this.state.labelClaimList &&
                      this.state.labelClaimList.length === 0
                      && this.state.tableStatus === "" ? null : ""}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default LabelClaimMaster;
